// components/HeaderBar.jsx
import React from 'react';
import { Layout, Input, Avatar, Space, Tooltip, Dropdown, Menu } from 'antd';
import { Button } from "antd";
import {
  AppstoreOutlined,
  BellOutlined,
  UserOutlined,
  SettingOutlined,
  SearchOutlined,
  ProjectOutlined,
  FundProjectionScreenOutlined,
  DownOutlined,
} from '@ant-design/icons';

const { Header } = Layout;

const HeaderBar = () => {
  const onMenuClick = (e) => {
    // console.log(e, 'event');
  };

  const startTourAgain = () => {
  
  window.dispatchEvent(new Event("restart-project-tour"));
};

  const yourWorkMenu = (
    <Menu onClick={onMenuClick}>
      <Menu.Item key="recent">Recently Viewed</Menu.Item>
      <Menu.Item key="assigned">Assigned to Me</Menu.Item>
      <Menu.Item key="starred">Starred</Menu.Item>
    </Menu>
  );

  const projectsMenu = (
    <Menu onClick={onMenuClick}>
      <Menu.Item key="all-projects">All Projects</Menu.Item>
      <Menu.Item key="create-project">Create Project</Menu.Item>
      <Menu.Item key="favorite-projects">Favorite Projects</Menu.Item>
    </Menu>
  );

  return (
    <Layout>
      <Header
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          background: '#fff',
          color: 'black',
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px',
          height: 64,
          zIndex: 2000,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div
          style={{
            color: 'black',
            fontSize: 20,
            fontWeight: 600,
            marginRight: 32,
            whiteSpace: 'nowrap',
          }}
        >
          Tasks
        </div>

        {/* Navigation */}
        <Space size="large" style={{ flex: 1 }}>
          <Dropdown overlay={yourWorkMenu} trigger={['hover']}>
            <a onClick={(e) => e.preventDefault()} style={{ color: 'black' }}>
              <UserOutlined /> Your Work{' '}
              <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
            </a>
          </Dropdown>

          <Dropdown overlay={projectsMenu} trigger={['hover']}>
            <a onClick={(e) => e.preventDefault()} style={{ color: 'black' }}>
              <ProjectOutlined /> Projects{' '}
              <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
            </a>
          </Dropdown>

          <a
            onClick={() => console.log('Dashboards')}
            style={{ color: 'black' }}
          >
            <FundProjectionScreenOutlined /> Dashboards
          </a>

          <a onClick={() => console.log('Apps')} style={{ color: 'black' }}>
            <AppstoreOutlined /> Apps
          </a>
        </Space>

        {/* Search */}
        <Input
          placeholder="Search"
          prefix={<SearchOutlined />}
          allowClear
          style={{
            width: 250,
            marginRight: 24,
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.2)',
          }}
        />

        {/* Right Icons */}
        <Space size="middle">
          <Tooltip title="Notifications">
            <BellOutlined style={{ color: 'black', fontSize: 18 }} />
          </Tooltip>
          <Tooltip title="Settings">
            <SettingOutlined style={{ color: 'black', fontSize: 18 }} />
          </Tooltip>
          <Tooltip title="Profile">
            <Avatar
              style={{ backgroundColor: '#722ed1' }}
              icon={<UserOutlined />}
            />
          </Tooltip>
        </Space>
      </Header>
    </Layout>
  );
};

export default HeaderBar;
